export default {"src":"/_next/static/media/cx2.f6c32351.svg","height":116,"width":174,"blurWidth":0,"blurHeight":0};